import React from 'react';
import PropTypes from 'prop-types';

export default class RoomSwitcher extends React.Component {
    static propTypes = {
        tour: PropTypes.any,
    }

    state = {
        selectedFloorId: undefined,
        selectedRoomId: undefined,
    }

    componentDidUpdate(prevProps) {
        if (this.props.tour !== prevProps.tour ||
            this.state.selectedFloorId === undefined ||
            this.state.selectedRoomId === undefined
        ) {
            const {floor, room} = this.getCurrentFloorAndRoom();
            const selectedFloorId = floor ? floor.get('id') : undefined;
            const selectedRoomId = room ? room.get('id') : undefined;
            if (selectedFloorId !== this.state.selectedFloorId || selectedRoomId !== this.state.selectedRoomId) {
                this.setState({selectedFloorId, selectedRoomId});
            }
        }
    }

    onSelectFloor = (floor_id) => {
        if (floor_id !== this.state.selectedFloorId) {
            this.setState({selectedFloorId: floor_id, selectedRoomId: undefined});
        }
    }

    onSelectRoom = (room_id) => {
        if (room_id !== this.state.selectedRoomId) {
            this.setState({selectedFloorId: undefined, selectedRoomId: room_id});
        }
    }

    getCurrentFloorAndRoom = () => {
        const {
            selectedFloorId,
            selectedRoomId,
        } = this.state;
        const {
            tour,
        } = this.props;
        if (!tour) {return {}}
        for (const floor of tour.get('floors')) {
            if (selectedFloorId === undefined || floor.get('id') === selectedFloorId) {
                for (const room of floor.get('rooms')) {
                    if (selectedRoomId === undefined || room.get('id') === selectedRoomId) {
                        return {floor, room};
                    }
                }
                if (selectedFloorId !== undefined) {
                    return {floor, room: undefined};
                }
            }
        }
        return {};
    }

}
